import { MutationTree, GetterTree } from 'vuex';
import { State, Data } from '@root/modules/article/types/article';

export const state: () => State = () => ({
  articlesWithBodyContent: [],
  crArticles: [],
  activeArticleId: null,
  activeArticle: null,
  activeArticlePath: null,
  articleCxenseArticles: null,
  articleCxenseHeadlines: null,
  scrollDirection: null,
  multimedijaArticles: null,
  composerTarget: null,
  mistakeReportVisible: false,
  isAdultConfirmed: false,
});

export const getters: GetterTree<State, Record<string, unknown>> = {
  getBodyContentStatus: (state) => (articleId: string) => {
    return state.articlesWithBodyContent.find((id) => id === articleId);
  },
  getCrArticles: (state) => {
    return state.crArticles;
  },
  getActiveArticleId: (state) => state.activeArticleId,
  getActiveArticle: (state) => state.activeArticle,
  getActiveArticlePath: (state) => state.activeArticlePath,
  getArticleCxenseArticles: (state) => state.articleCxenseArticles,
  getArticleCxenseHeadlines: (state) => state.articleCxenseHeadlines,
  getMultimedijaArticles: (state) => state.multimedijaArticles,
  getComposerTarget: (state) => state.composerTarget,
  getMistakeReportVisible: (state) => state.mistakeReportVisible,
  getIsAdultConfirmed: (state) => state.isAdultConfirmed,
};

export const mutations: MutationTree<State> = {
  setCrArticles(state, crArticles: string[] | []) {
    state.crArticles = crArticles;
  },
  setActiveArticleId(state, articleId: string) {
    state.activeArticleId = articleId;
  },
  setActiveArticlePath(state, articlePath: string) {
    if (state.activeArticlePath !== articlePath) {
      state.activeArticlePath = articlePath;
    }
  },
  setActiveArticle(state, article: Data) {
    state.activeArticle = article;
  },
  setArticleCxenseArticles(state, cxenseArticles: State['articleCxenseArticles']) {
    state.articleCxenseArticles = cxenseArticles;
  },
  setArticleCxenseHeadlines(state, cxenseHeadlines: State['articleCxenseHeadlines']) {
    state.articleCxenseHeadlines = cxenseHeadlines;
  },
  setScrollDirection(state, value: string) {
    state.scrollDirection = value;
  },
  setMultimedijaArticles(state, multimedijaArticles: State['multimedijaArticles']) {
    state.multimedijaArticles = multimedijaArticles;
  },
  setComposerTarget(state, value: number) {
    state.composerTarget = value;
  },
  toggleMistakeReport(state) {
    state.mistakeReportVisible = !state.mistakeReportVisible;
  },
  setIsAdultConfirmed(state, value: boolean) {
    state.isAdultConfirmed = value;
  },
};
